import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps, UserProps } from './models';

export const  getAuthUrl = async (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/feishu/authUrl`, {params});
}

export const checkState = async (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/feishu/checkState`, {params});
}
export const  downloadMbConfig = async (companyId: string, adeId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/mobileconfig?companyId=${companyId}&adeId=${adeId}`);
}

export const mdmUserLogin = async (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mdm/users/login`, params);
}

